import {
  Injectable,
} from '@angular/core';
import { Observable, combineLatest, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ZefPermissionService {
  private _store = {};

  define(name: string, validation) {
    this._store[name] = validation;
  }

  authorize(authObj: any) {
    const modes = [ 'only', 'except', 'all' ].filter((mode) => !!authObj[mode]);

    if (modes.length > 1) {
      throw new Error(`Authorization object cannot combine [${modes.join('], [')}]`);
    }

    if (authObj.only) {
      return this._checkAuthorization(authObj.only, 'only');
    }

    if (authObj.except) {
      return this._checkAuthorization(authObj.except, 'except');
    }

    if (authObj.all) {
      return this._checkAuthorization(authObj.all, 'all');
    }

  }

  /**
   * - only:   passes when ANY listed permission passes
   * - except: passes when NONE of the listed permissions pass
   * - all:    passes when EVERY listed permission passes
   *
   * An undefined permission name fails rather than being skipped — skipping silently
   * widens the rule, which for `all` means granting access on a typo.
   */
  private _checkAuthorization(names, type) {
    const mergeObsrArr: Array<Observable<boolean>> = [];

    names.forEach((res: any) => {
      if (this._store[res]) {
        mergeObsrArr.push(this._store[res].call());
      } else {
        console.warn(`Permission: No defined validation for ${res}`);
        mergeObsrArr.push(of(false));
      }
    });

    return combineLatest([ ...mergeObsrArr ]).pipe(
      map((res: boolean[]) => {

        if (type === 'all') {
          return res.every((x) => x === true);
        }

        const r = res.some((x) => x === true);
        if (type === 'only') {
          return !!r;
        }
        if (type === 'except') {
          return !r;
        }
      })
    );
  }
}
